<template>
  <div
    class="mheader"
    :style="{
      backgroundColor: user.event_color,
      backgroundImage: 'url(' + user.event_logo + ')',
    }"
    @click="handleClick"
  ></div>
</template>

<script>
export default {
  name: 'LeftMenuHeader',
  props: {
    user: {
      type: Object,
      required: true
    },
    showOptions: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleClick () {
      if (this.showOptions) {
        this.$emit('click')
      }
    }
  }
}
</script>

<style lang="scss" scoped src="@/styles/_left_menu.scss">
/* you can leave this empty or add component-specific overrides */
</style>
